'use client';

import { formatDateVN } from '@/common/ultils';
import { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

export default function DatePickerModal({ value, onChange }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Nút mở modal */}
      <button onClick={() => setOpen(true)} className="flex items-center p-2 border border-gray-600 text-gray-700 rounded-lg cursor-pointer">
        <svg className="w-4 h-4 text-gray-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a
1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2
2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2
2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1
0 2H5a1 1 0 0 1 0-2Z"
          />
        </svg>

        {value ? formatDateVN(value) : 'Xem tin theo ngày'}
      </button>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-xl shadow-lg">
            <DayPicker
              mode="single"
              selected={value}
              onSelect={(d) => {
                onChange(d);
                setOpen(false);
              }}
            />

            <button className="w-full mt-2 p-2 bg-gray-200 rounded-lg" onClick={() => setOpen(false)}>
              Đóng
            </button>
          </div>
        </div>
      )}
    </>
  );
}
